<template>
  <HeadTitle
    title="Crear usuario"
    description="Formulario de creación de usuario"
  />
  <br />
  <form
    class="grid md:w-full sm:col-12 md:p-2 lg:w-6 mt-3 lg:w-10 mt-3 gap-2"
    @submit.prevent="save"
  >
    <div class="flex flex-column md:col-6 lg:col-4">
      <label for="employee">Empleado</label>
      <AutoComplete
        v-model="selectedEmployee"
        :optionLabel="employeeLabel"
        :suggestions="filteredEmployees"
        @complete="searchEmployees"
        class="mt-2"
      >
        <template #option="slotProps">
          <div class="flex align-options-center">
            <div>
              {{ slotProps.option.code + ' - ' + slotProps.option.name }}
            </div>
          </div>
        </template>
      </AutoComplete>
    </div>

    <div class="flex flex-column sm:col-12 md:p-2 md:col-6 lg:col-4">
      <label for="name">Nombre<span class="text-red-300 ml-1">*</span></label>
      <InputText id="name" v-model="name" class="mt-2" />
      <small class="p-error">{{ nameError || '&nbsp;' }}</small>
    </div>

    <div class="flex flex-column sm:col-12 md:p-2 md:col-6 lg:col-4">
      <label for="email"
        >Correo electrónico<span class="text-red-300 ml-1">*</span></label
      >
      <InputText id="email" v-model="email" class="mt-2" />
      <small class="p-error">{{ emailError || '&nbsp;' }}</small>
    </div>

    <div class="flex flex-column sm:col-12 md:p-2 md:col-6 lg:col-4">
      <label for="role"
        >Tipo de usuario<span class="text-red-300 ml-1">*</span></label
      >
      <Dropdown
        v-model="selectedRole"
        :options="roles"
        optionLabel="renamedLabel"
        placeholder="Seleccionar rol"
        class="mt-2"
      />
      <small class="p-error">{{ roleError || '&nbsp;' }}</small>
    </div>
    <div
      class="flex flex-row sm:col-12 md:p-2 md:col-6 lg:col-4 align-self-center"
      v-if="isRRHHAccessible"
    >
      <label for="isRRHH" class="mb-2">Habilitar acceso RRHH</label>
      <InputSwitch class="ml-2" id="isRRHH" v-model="isRRHH" />
    </div>
    <div
      class="flex flex-column sm:col-12 md:p-2 md:col-6 lg:col-4"
      v-if="isCompanySelectionVisible"
    >
      <label for="companies">Compañias</label>
      <MultiSelectDialog
        id="companies"
        label="Compañias"
        header-title="Seleccionar compañias"
        :options="userCompanies || []"
        v-model="selectedCompanies"
        show-key="formattedLabel"
        value-key="id"
        class="w-auto mt-2 mr-5"
        :disabled="false"
        :required="false"
      />
      <small class="p-error">&nbsp;</small>
    </div>
    <div
      class="flex flex-column sm:col-12 md:p-2 md:col-6 lg:col-4"
      v-if="isModuleSelectionVisible"
    >
      <label for="modules">Módulos</label>
      <MultiSelectDialog
        id="modules"
        label="Módulos"
        header-title="Seleccionar módulos"
        :options="adminModules || []"
        v-model="selectedModules"
        show-key="name"
        value-key="id"
        class="w-auto mt-2 mr-5"
        :disabled="false"
        :required="false"
      />
      <small class="p-error">&nbsp;</small>
    </div>
  </form>
  <Footer>
    <Button
      severity="secondary"
      label="Cancelar"
      @click="router.back()"
      class="mr-2 text-sm font-light"
    />
    <Button
      label="Guardar"
      @click="save"
      severity="primary"
      class="text-sm font-light"
    />
  </Footer>
</template>

<script setup lang="ts">
  import { useUserForm } from '../composables/useUserForm'
  import Footer from '@/shared/components/Footer.vue'
  import HeadTitle from '@/shared/components/HeadTitle.vue'
  import MultiSelectDialog from '@/shared/components/MultiSelectDialog.vue'

  const {
    name,
    email,
    selectedRole,
    selectedEmployee,
    selectedCompanies,
    selectedModules,
    isRRHH,
    roles,
    adminModules,
    userCompanies,
    filteredEmployees,
    nameError,
    emailError,
    roleError,
    meta,
    isCompanySelectionVisible,
    isModuleSelectionVisible,
    isRRHHAccessible,
    save,
    searchEmployees,
    employeeLabel,
    router,
  } = useUserForm()
</script>

<style scoped>
  :deep(.p-inputtext) {
    width: 100%;
  }
  .p-error {
    min-height: 1.2rem; /* Prevent layout shift */
  }
</style>
